// i18n area 'apps' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.ru-RU.meta.json.
import type { enUS } from './apps'

export const ruRU: typeof enUS = {

  // Приложения, волна 1 (Annex R): управляемые контейнеры podman — под надзором
  // воркера на объявленном узле; образ = lockfile branch@digest (Annex Q)
  // с политикой pinned/tracking; нетегированное подключение L3 со статическим IP.
  apps: {
    title: 'Приложения',
    create: 'Создать приложение',
    createTitle: 'Создание приложения',
    editTitle: 'Изменение приложения',
    name: 'Имя',
    nameHint: 'DNS-1123, уникальное в скоупе — неизменяемое после создания.',
    node: 'Узел',
    nodeHint: 'Узел-участник, который его обслуживает — размещение задается явно (планировщик появится позже).',
    image: 'Образ',
    editImageHint: 'Новая ссылка заново разрешается через инвентарь — это и есть жест фиксации или отката.',
    imagePolicy: 'Политика',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Дайджест меняется только по команде.',
    policyTrackingHint: 'Автоматическое обновление, как только refresh сдвинет ветку.',
    archMovePolicy: 'Перемещение cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Что происходит, если app перемещают на node другой архитектуры: refuse отклоняет перемещение, reresolve заново разрешает lockfile из branch на новой arch — содержимое меняется, и ответ называет изменение digest.',
    network: 'Сеть',
    networkHint: 'Нетегированное подключение L3: логическая сеть фабрики (рекомендуется — шлюз и DNS берутся из единого источника), оверлейная сеть или голый бридж узла (не рекомендуется).',
    overlayPrefix: 'оверлей:',
    fabricPrefix: 'фабрика:',
    bridgePrefix: 'бридж узла:',
    ipAssignment: 'Назначение IP',
    ipStatic: 'Статическое',
    ipAuto: 'Автоматическое (IPAM)',
    ipAssignmentHint_static: 'Адрес задаете вы, прямо сейчас.',
    ipAssignmentHint_auto: 'IPAM выберет свободный адрес из диапазонов сети, отведенных под TVirt.',
    bridgeDiscouraged: 'Голый бридж узла — НЕ РЕКОМЕНДУЕТСЯ: TVirt ничего не знает о его адресации, поэтому шлюз и DNS придется задать вручную. Рекомендуемый путь — логическая сеть фабрики.',
    ip: 'IP',
    ipHint: 'Статический IPv4 внутри подсети подключения.',
    ipCidrHint: 'В форме CIDR на голом бридже (напр. 192.168.1.10/24) — префикс неоткуда вывести.',
    gateway: 'Шлюз',
    gatewayManualHint: 'Вручную — голый бридж ничего не выводит сам.',
    dnsServers: 'Серверы DNS',
    dnsManualHint: 'Вручную, через запятую — минимум один.',
    rootKind: 'Корневая ФС',
    rootEphemeral: 'эфемерная',
    rootPersistent: 'постоянная',
    rootEphemeralHint: 'Пересоздается из образа при каждом пересоздании; живет в эфемерном хранилище кластера.',
    rootEphemeralHintNamed: 'Пересоздается из образа при каждом пересоздании; живет в эфемерном хранилище кластера ({name}).',
    rootPersistentHint: 'Переживает перезапуски; живет в том хранилище, которое вы выберете.',
    rootStorage: 'Хранилище корневой ФС',
    editRootStorageHint: 'Корневая ФС заново разворачивается в новом пуле — существующие данные сами НЕ переезжают.',
    volumes: 'Тома',
    volumeAdd: 'Добавить том',
    volumeName: 'Имя',
    volumeMountPath: 'Путь монтирования',
    volumeKind: 'Тип',
    volumeStorage: 'Хранилище',
    devices: 'Устройства',
    deviceClassHint: 'Запрашивается КЛАСС (тег gpu-device или usb-device), никогда не конкретное устройство: у объявленного узла должно быть устройство, помеченное для приложений. Несколько приложений могут использовать одно устройство — контейнер разделяет его, а не отбирает у хоста.',
    deviceSlot: 'Слот',
    deviceTag: 'Тег',
    deviceValue: 'Класс',
    deviceUnresolved: 'сейчас ничего не разрешается',
    noDeviceTags: 'Тега вида gpu-device или usb-device пока нет: создайте его и назначьте устройствам, помеченным для приложений.',
    env: 'Окружение',
    envHint: 'По одной паре КЛЮЧ=значение в строке.',
    secretEnvTitle: 'Секретные переменные',
    secretEnvNotice: 'Секретное значение больше никогда не возвращается из API: его никто не прочитает снова, даже тот, кто его записал. В контрольной точке оно едет запечатанным мастер-паролем, поэтому восстановление без мастер-пароля попросит ввести его заново.',
    secretEnvPromote: 'Сделайте секретной одну из переменных, записанных выше:',
    secretEnvAdd: 'Добавить секретную переменную',
    secretEnvName: 'Имя',
    secretEnvValue: 'Значение',
    secretEnvKept: 'сохранено — оставьте пустым, чтобы не менять',
    secretEnvWithdrawWarning: 'Чтобы перестать считать секретной переменную, которая уже секретна, запишите ей новое значение: снять один только маркер значило бы ПРОЧИТАТЬ то, что из хранилища не выходит. Удаление же переменной её стирает.',
    secretEnvChip: 'секретно',
    startNow: 'Запустить сразу (иначе приложение создается остановленным)',
    deletePersistentIntro: 'У этого приложения есть постоянные данные — выберите, что с ними делать:',
    deleteKeepData: 'Сохранить данные (директории останутся в своих хранилищах, осиротевшими)',
    deletePurgeData: 'Удалить данные вместе с приложением',
    phase: 'Фаза',
    phase_running: 'Запущено',
    phase_stopped: 'Остановлено',
    phase_error: 'Ошибка',
    phase_unknown: 'Неизвестно',
    desiredState: 'Желаемое',
    wantedRunning: 'запущено',
    wantedStopped: 'остановлено',
    start: 'Запустить',
    stop: 'Остановить',
    restart: 'Перезапустить',
    refreshImage: 'Обновить образ (принять новый @current)',
    logs: 'Журнал',
    logsTitle: 'Журнал',
    logsEmpty: 'Вывод не захвачен.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App не запущена — shell нужен живой контейнер. Её логи можно читать в любом состоянии.',
    shellConnect: 'Подключиться',
    shellDisconnect: 'Отключиться',
    shellExited: 'Сессия завершилась с кодом выхода {code}.',
    shellEndedWithoutStatus: 'Сессия завершилась без статуса выхода: {reason}',
    shellRevoked: 'Ticket сессии больше недействителен — он истёк, или вход, который его открыл, был отозван.',
    shellHint: 'Нажмите на чёрное поле и печатайте: клавиши доходят до контейнера. Ctrl+C и стрелки работают; exit закрывает shell.',
    shellStatus: {
      connecting: 'Подключение…',
      connected: 'Подключена',
      ended: 'Завершена'
    },
    deleteRunningError: 'Для приложения «{name}» задано состояние «запущено» — сначала остановите его.',

    // Стандартный диалог (раунд #156): вкладки карточки и недостающие поля
    // контракта — каждое поле приложения на виду, замки с объяснением.
    tabs: {
      general: 'Общее',
      image: 'Образ',
      network: 'Сеть',
      storage: 'Хранилище',
      devices: 'Устройства',
      observed: 'Наблюдаемое'
    },
    attachment: 'Подключение',
    runningDigest: 'Дайджест в работе',
    lastError: 'Последняя ошибка',
    reportObservedAt: 'Последний отчет воркера',
    desiredStateLock: 'Управляется действиями «Запустить» и «Остановить» — прямое изменение недоступно.',
    ipEditDisabledHint: 'Изменяется только при статическом назначении.',
    derivedFromNetworkHint: 'Выводится из единого источника сети — вручную только на голом бридже со статическим IP.',
    ephemeralUnset: 'не настроено',
    ephemeralMissing: 'Эфемерное хранилище приложений не настроено — создание приложения с эфемерными частями (корневая ФС или тома) будет отклонено, пока вы его не зададите.',
    ephemeralCurrent: 'Эфемерное хранилище приложений: {name}',
    ephemeralMissingCreate: 'У этого приложения есть эфемерные части, но эфемерное хранилище приложений не задано — создание будет отклонено. Задайте его сначала в баннере на странице приложений.',
    setEphemeral: 'Задать эфемерное хранилище',
    changeEphemeral: 'Сменить эфемерное хранилище',
    setEphemeralTitle: 'Задать эфемерное хранилище приложений',
    changeEphemeralTitle: 'Сменить эфемерное хранилище приложений',
    ephemeralStorageHint: 'ЗНАЧЕНИЕ ПО УМОЛЧАНИЮ для кластера: файловый пул, где живут корневые ФС и эфемерные тома каждого приложения, если приложение не объявило собственное переопределение. Смена не выполняется на горячую и ничего не перезапускает: она вступает в силу со следующего запуска каждого приложения — эфемерные данные никуда не переезжают.',
    ephemeralPool: 'Пул хранилища',
    ephemeralOverride: 'Эфемерное хранилище (переопределение для приложения)',
    ephemeralOverrideInherit: 'Наследовать значение кластера по умолчанию',
    ephemeralOverrideInheritNamed: 'Наследовать значение кластера по умолчанию ({name})',
    ephemeralOverrideHint: 'Собственный пул приложения под корневую ФС и эфемерные тома — оставьте пустым, чтобы наследовать значение кластера по умолчанию. Смена не выполняется на горячую и ничего не перезапускает: она вступает в силу со следующего запуска (эфемерные данные возродятся пустыми в новом пуле) и требует права app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'переопределение',

    imageAnyBranch: 'Все ветки',
    imageBranchHint: 'Сужает образы до названных этой веткой; без ветки видны все образы репозитория.',
    imageDigestHint: 'Содержимое: выбирается из таблицы дайджестов, которая несёт его происхождение и архитектуру. Одна и та же ветка предлагает по одному на архитектуру, и они не взаимозаменяемы.',
    imageLockfile: 'Разрешённая ссылка',
    imageNoImages: 'Для этого репозитория нет образов в кеше — скачай один из раздела Образы OCI.',
    imageHeadNotCached: 'нет в кэше — скачивается при запуске',
    imageNoRegistries: 'Не зарегистрировано ни одного репозитория: зарегистрируй один, чтобы можно было выбрать образ.',
    imageChosenHint: 'Образ выбирается каскадом в диалоге изменения: ссылка никогда не набирается вручную.',
    registerRepositoryHint: 'Регистрация ничего не скачивает: она делает репозиторий наблюдаемым, чтобы образ можно было выбрать, не покидая этот диалог.',
    registerRepositoryBranchHint: 'Необязательно: первая наблюдаемая ветка (напр. latest).',
    registerRepositoryElsewhere: 'Искомый репозиторий не зарегистрирован: регистрация делается в разделе Образы OCI тем, у кого есть право.'
  },

  // Шаблоны CT (раунд K2 #63): МАТЕРИАЛИЗОВАННЫЕ объекты CT — импорт из
  // каталога есть единственный вход; файлы загружаются внутрь каталогов.
  cts: {
    createAction: 'Создать CT',
    createTitle: 'Создание контейнера из шаблона',
    createError: 'Контейнер не создан',
    template: 'Шаблон CT',
    noTemplates: 'Шаблонов CT нет — импортируйте один в разделе «Шаблоны CT»',
    resources: 'Ресурсы',
    node: 'Узел',
    phase: {
      defined: 'Ни разу не запускался',
      materializing: 'Материализуется',
      ready: 'Готов',
      starting: 'Запускается',
      running: 'Работает',
      stopping: 'Останавливается',
      stopped: 'Остановлен',
      deleting: 'Удаляется',
      error: 'В состоянии ошибки'
    },
    actions: {
      start: 'Запустить',
      stop: 'Остановить',
      restart: 'Перезапустить',
      markTemplate: 'Повысить до шаблона CT',
      error: 'Действие отклонено'
    },
    markTemplate: {
      confirmTitle: 'Повысить «{name}» до шаблона CT?',
      confirmBody: 'Контейнер уходит из этого списка в раздел «Шаблоны CT» и сразу готов порождать новые CT. Метаданные остаются изменяемыми, и в любой момент его можно вернуть в CT.',
      confirm: 'Повысить',
      moved: '«{name}» теперь шаблон CT — ищите его в разделе «Шаблоны CT».'
    },
    stopCause: {
      api: 'Остановлен через TVirt',
      'ct-exit': 'Контейнер завершился сам',
      'host-reboot': 'Не пережил перезагрузку узла',
      'start-failed': 'Запуск не удался — в ошибке задачи сказано, чего не хватает и как это исправить'
    },

    console: 'Консоль',
    consoleUnavailable: 'Контейнер не работает — консоли нужен живой контейнер. Журнал же читается в любом состоянии.',
    consoleNoTemplate: 'Шаблон никогда не работает, поэтому у него нет консоли: создайте из него CT и откройте его консоль.',
    consoleConnect: 'Подключиться',
    consoleDisconnect: 'Отключиться',
    consoleReconnect: 'Переподключиться',
    consoleTakenBy: 'Эту консоль занял другой оператор ({user}). Одна консоль на контейнер: переподключение забирает её обратно.',
    consoleHint: 'Щёлкните по чёрному полю и печатайте: клавиши доходят до контейнера. Ctrl+C и стрелки работают.',
    consoleEndpointDown: 'Точка доступа консоли не открывается на узле, обслуживающем container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container не запущен — shell нужен живой container. Его логи читаются в любом состоянии.',
    shellNoTemplate: 'Template никогда не запускается, поэтому у него нет shell: создайте из него CT и откройте его shell.',
    shellConnect: 'Подключиться',
    shellDisconnect: 'Отключиться',
    shellExited: 'Сессия завершилась с кодом выхода {code}.',
    shellEndedWithoutStatus: 'Сессия завершилась без статуса выхода: {reason}',
    shellRevoked: 'Ticket сессии больше недействителен — он истёк, или вход, который его открыл, был отозван.',
    shellHint: 'Нажмите на чёрное поле и печатайте: клавиши доходят до контейнера. Ctrl+C и стрелки работают; exit закрывает shell.',
    shellStatus: {
      connecting: 'Подключение…',
      connected: 'Подключена',
      ended: 'Завершена'
    },
    rootPassword: 'Пароль root',
    rootPasswordHint: 'Записывается один раз в скопированный rootfs (в виде hash, больше не показывается). В образах дистрибутивов нет пароля root: без него shell — единственный вход.',
    sshKeys: 'Публичные SSH-ключи root',
    sshKeysHint: 'По одному публичному ключу OpenSSH на строку, в root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Подключение…',
      connected: 'Подключена',
      reconnecting: 'Переподключение…'
    },
    logs: 'Журнал',
    logsTitle: 'Журнал',
    logsEmpty: 'Вывод не захвачен.',
    logsSource: 'Какой журнал',
    logsSourceConsole: 'Консоль init контейнера — почему служба внутри не запустилась',
    logsSourceSupervisor: 'Супервизор liblxc — почему контейнер так и не дошёл до запуска',
    logsNeverStarted: 'Его ни разу не запускали, поэтому записанного пока нет — запустите его, и журнал появится, даже если запуск не удастся.',
    logsNoTemplate: 'Шаблон никогда не работает, поэтому он ничего никогда не записывал.',
    logsError: 'Журнал не удалось захватить',

    // Стандартный диалог (раунд #156): вкладки карточки, общие для списков
    // CT и шаблонов CT, плюс замки с объяснением.
    tabs: {
      general: 'Общее',
      hardware: 'Оборудование',
      network: 'Сеть',
      provenance: 'Происхождение'
    },
    templateFlag: 'Шаблон CT',
    templateLock: 'Меняется только действиями «Повысить» и «Вернуть в CT» — прямое изменение недоступно.',
    sourceLock: 'Происхождение, записанное при рождении — никогда не переписывается; исчезнувший источник оставляет голую ссылку.',
    storageLock: 'Задается при создании — перенос корневой ФС появится в одном из будущих раундов.',
    startedAt: 'Запущен',
    lastStop: 'Последняя остановка',
    editNicsTitle: 'Изменение сетей',
    nicDisconnected: 'отключена'
  },
  ctTemplates: {
    title: 'Шаблоны CT',
    importAction: 'Импортировать из каталога',
    importTitle: 'Импорт шаблона CT из каталога',
    importSubmit: 'Импортировать',
    importError: 'Импорт отклонен',
    importHint: 'Материализация копирует корневую ФС в выбранное хранилище — файл каталога остается нетронутым. Чтобы добавить новые файлы, сначала загрузите их в каталог.',
    sourceFile: 'Файл шаблона CT',
    sourceFileHint: 'Файлы ct-rootfs выбранного каталога, только готовые',
    noFiles: 'В этом каталоге нет готовых файлов ct-rootfs — загрузите файл со страницы каталога',
    source: 'Исходный файл',
    rootfsStorage: 'Хранилище корневой ФС',
    rootfsStorageHint: "Где живет распакованное дерево корневой ФС — хранилище с файловой системой и достаточным свободным местом под распакованный размер плюс около 1 GiB запаса (иначе импорт завершится ошибкой).",
    resources: 'Ресурсы',
    cores: 'vCPU',
    memoryMiB: 'Память (MiB)',
    cpuLimit: 'Предел CPU',
    cpuLimitHint: 'Эквиваленты ядер узла (напр. 1.5); пусто = без потолка',
    cpuUncapped: 'без потолка',
    cpuWeight: 'Вес CPU',
    hostname: 'Имя хоста',
    hostnameHint: 'Пусто = имя CT',
    nameservers: 'Серверы имен DNS',
    dnsHint: 'Через запятую; пусто = наследуются от хоста',
    searchDomains: 'Домены поиска DNS',
    dnsInherited: 'Унаследовано от хоста',
    networks: 'Сети',
    nicSlot: 'Слот NIC',
    phase: {
      materializing: 'Материализуется',
      ready: 'Готов',
      deleting: 'Удаляется',
      error: 'Ошибка'
    },
    exportAction: 'Экспортировать в каталог',
    exportTitle: 'Экспорт в каталог',
    exportSubmit: 'Экспортировать',
    exportError: 'Экспорт отклонен',
    exportHint: 'Упаковывает материализованную корневую ФС в НОВЫЙ файл ct-rootfs в выбранном каталоге — шаблон остается нетронутым.',
    exportName: 'Имя файла',
    exportNameHint: 'Пусто = <template>-export-<n>',
    markCt: {
      action: 'Вернуть в CT',
      confirmTitle: 'Вернуть «{name}» в CT?',
      confirmBody: 'Шаблон уходит из этого списка обратно в список CT и снова может запускаться. Пока вы не повысите его снова, создавать из него CT нельзя.',
      confirm: 'Вернуть в CT',
      moved: '«{name}» снова стал CT — ищите его в списке CT.'
    }
  },

  // OCI, волна 1 (Annex Q — модель «тег как ветка»): тег OCI — это ветка
  // (подвижный указатель), дайджест — коммит; refresh = «git fetch»,
  // pull = разреши СЕЙЧАС и скачай ИМЕННО ЭТОТ дайджест.
  oci: {
    registriesTitle: 'Реестры OCI',
    imagesTitle: 'Образы OCI',
    provider: 'Провайдер',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Универсальный',
    providerImmutableHint: 'Провайдер неизменяем после создания — другой провайдер означает новый реестр.',
    url: 'URL',
    urlHintPreset: 'Заполнен по провайдеру — переопределяйте только ради зеркал.',
    urlHintRequired: 'Обязателен для универсальных реестров: базовый URL вида https://.',
    urlHintEcr: 'Обязателен: конечные точки ECR свои для каждого аккаунта и региона — готовой заготовки не бывает.',
    credential: 'Учетные данные',
    credentialNone: 'Анонимный доступ',
    credentialHint: 'Запись хранилища учетных данных вида «пользователь и пароль»; воркеры получают ее в момент использования — никаких файлов auth на каждом узле.',
    nameHint: 'Имя в стиле хоста (docker.io, registry.intra); уникально в пределах скоупа, неизменяемо',
    addRegistry: 'Добавить реестр',
    addRegistryTitle: 'Добавление реестра OCI',
    verify: 'Проверить',
    verifyState: 'Проверка',
    verified: 'Проверен',
    verifyFailed: 'Не пройдена',
    neverVerified: 'Ни разу не проверялся',
    registryInUseError: 'У «{name}» еще есть зарегистрированные репозитории — сначала удалите их.',
    repositories: 'Репозитории',
    repositoriesHint: 'Регистрация лишь ставит ветки (теги OCI) под наблюдение — ничего не скачивается. Обновление разрешает каждую наблюдаемую ветку и ведет журнал ссылок.',
    noRepositories: 'В этом реестре нет зарегистрированных репозиториев.',
    registerRepository: 'Зарегистрировать репозиторий',
    repoPath: 'Путь',
    repoPathHint: 'Путь репозитория в реестре, напр. «example» или «library/nginx»',
    branches: 'Ветки',
    branchesHint: 'Наблюдаемые ветки (теги OCI), через запятую — напр. 1.1.0, 1.1.1',
    branch: 'Ветка',
    branchPullHint: 'Разрешается СЕЙЧАС: скачивается тот дайджест, на который ветка указывает сегодня.',
    refresh: 'Обновить',
    deleteRepository: 'Удалить репозиторий',
    reflogCount: 'предыдущих: {n}',
    noResolutions: 'Ни разу не обновлялось — ни одного разрешения ветки не зафиксировано.',
    refreshFailed: 'Последнее обновление не удалось ({when})',
    loadError: 'Не удалось загрузить репозитории.',
    reference: 'Ссылка',
    digest: 'Дайджест',
    digestHint: 'sha256:… — точный образ, без ветки (detached)',
    size: 'Размер',
    nodes: 'Узлы',
    detached: 'detached',
    detachedHint: 'Скачан по дайджесту, без ветки — контроль дрейфа неприменим.',
    pulledAt: 'Скачан',
    pull: 'Скачать',
    pullTitle: 'Скачивание образа',
    pullHint: 'Предварительный прогрев, а не обязательное условие: скачивание по ветке разрешает ее СЕЙЧАС и берет ИМЕННО ТОТ дайджест; скачивание по дайджесту дает detached.',
    pullError: 'Скачивание отклонено',
    pullMode: 'Скачивать по',
    pullModeBranch: 'Ветке (разрешить сейчас)',
    pullModeDigest: 'Дайджесту (detached)',
    pullModeBranchHint: 'Честное значение по умолчанию: как apt install — повторный запуск позже может дать другой образ.',
    pullModeDigestHint: 'Точный дайджест — воспроизводимость и откат; в обмен на отказ от контроля дрейфа.',

    // Схема с двумя кнопками (#88, ратификация вечером 2026-07-30): «из
    // реестра» — это существующее скачивание по шагам, «из каталога»
    // материализует готовый архив oci-image (путь для изолированных сред).
    importFromRegistry: 'Импортировать из реестра',
    importFromCatalog: 'Импортировать из каталога',
    importCatalogTitle: 'Импорт образа OCI из каталога',
    importCatalogHint: 'Путь для изолированных сред: готовый архив oci-image (tar/tar.gz — docker-archive или oci-archive) материализуется в хранилище образов со ссылкой catalog/<каталог>/<файл>@<дайджест>; приложения используют его как любой другой образ. Архивы загружаются в каталоги — этот раздел только импортирует.',
    importCatalogFile: 'Архив',
    importCatalogFileHint: 'Готовые файлы oci-image выбранного каталога.',
    importCatalogNoFiles: 'В этом каталоге нет готовых архивов oci-image — загрузите один из карточки каталога.',
    importCatalogError: 'Импорт отклонен',
    registry: 'Реестр',
    repository: 'Репозиторий',
    cacheMissing: 'Кэш OCI кластера не настроен — скачивания отклоняются, пока вы не зададите пул хранилища.',
    setCache: 'Задать кэш',
    setCacheTitle: 'Настройка кэша OCI',
    setCacheHint: 'Пул УРОВНЯ КЛАСТЕРА ПО УМОЛЧАНИЮ, где лежат слои скачанных образов — скоуп может переопределить его собственным пулом (страница «Скоупы»). Смена не выполняется на горячую, ничего не перезапускает и не переносит слои: они лениво появятся вновь при следующем запуске или обращении.',
    cachePool: 'Пул хранилища',
    changeCache: 'Сменить кэш',
    changeCacheTitle: 'Смена пула кэша OCI',
    cacheCurrent: 'Кэш OCI кластера (по умолчанию): {name}',
    sectionOverview: 'Обзор',
    sectionRepositories: 'Репозитории',
    sectionExplore: 'Поиск в реестре',
    exploreHint: 'Живой удаленный поиск по реестру — для Docker Hub полный (описание, число загрузок, звезды), для остальных провайдеров по мере возможностей. Выберите результат, чтобы прочитать его полное описание и просмотреть удаленные теги; из тега можно добавить ссылку в репозиторий TVirt.',
    exploreSearch: 'Найти',
    exploreUnsupported: 'Этот провайдер не поддерживает поиск.',
    exploreNoResult: 'Подходящих репозиториев нет.',
    exploreNoTags: 'В этом репозитории нет подходящих тегов.',
    exploreOfficial: 'Официальный',
    explorePulls: 'Загрузки',
    exploreStars: 'Звезды',
    exploreUpdated: 'Обновлено {when}',
    exploreLoadMore: 'Загрузить еще',
    exploreSelectHint: 'Выберите результат: полное описание и удаленные теги загрузятся здесь.',
    exploreNoDescription: 'Этот провайдер не дает описания.',
    exploreTagsTitle: 'Удаленные теги',
    exploreTagFilter: 'Поиск тега',
    exploreAddToRepo: 'Добавить в репозиторий',
    exploreAdded: '{path}:{tag} теперь отслеживается — см. раздел «Репозитории».',
    addBranch: 'Добавить ветку',
    purgeRequiredTitle: 'Удалить «{name}» вместе с его образами?',
    purgeRequiredBody: 'Ни одно приложение этот репозиторий не использует, но скачанные образы еще существуют: удаление уберет и их записи, а кешированные блобы перейдут к сборщику мусора.',
    purgeConfirm: 'Удалить и образы',
    providerSelectHint: 'Выберите тип реестра: карточка рассказывает о заготовке URL и назначении.',
    providerDesc: {
      dockerhub: 'Публичный реестр Docker: URL заполнен заранее, полный поиск с описаниями и счетчиками.',
      ghcr: 'GitHub Container Registry: URL заполнен заранее; аккаунты используют personal access token.',
      ecr: 'Amazon Elastic Container Registry: конечные точки свои для каждого аккаунта и региона — URL нужно указать.',
      quay: 'Реестр Red Hat Quay: URL заполнен заранее.',
      generic: 'Самостоятельно размещенный реестр (Harbor, registry:2, …): URL https:// обязателен.'
    },

    // Стандартный диалог (раунд #156): поля карточки образа и реестра,
    // которых не было в колонках.
    layerCount: 'Слои',
    verifiedAt: 'Последняя проверка',
    verifyOk: 'Результат',
    verifyMessage: 'Сообщение проверки',

    // Модель #348/R39: образ ЕСТЬ дайджест — содержимое — а registry, репозиторий и ветка суть ИМЕНА, которые до него доходят.
    head: 'Вершина',
    heads: 'Вершины по архитектурам',
    listDigest: 'Дайджест списка',
    neverResolved: 'Ни разу не разрешен',
    totalSize: 'Общий размер',
    reflogTitle: 'История разрешений',
    usedBy: 'Использует',
    usageLockfile: 'lockfile',
    usageRunning: 'выполняется',
    evictable: 'можно вытеснить',
    evict: 'Вытеснить из кеша',
    evictHeadTitle: 'Вытеснить {digest}?',
    evictHeadBody: 'Это текущее разрешение как минимум одного коллектора: вытеснять его законно — это лишь кеш, удаленная ветка его по-прежнему отдает — но это не должно случиться по ошибке. Блоб ОДИН: вытеснение опустошает все коллекторы, которые его разделяют.',
    evictConfirm: 'Все равно вытеснить',

    arch: 'Архитектура',
    names: 'Имена',
    noNames: 'без имени',
    views: 'Представления',
    lastView: 'последнее представление',
    evictLastViewTitle: 'Убрать последнюю ссылку на {digest}?',
    evictLastViewBody: 'Это последнее представление этого содержимого: убрав его, образ перестаёт существовать в TVirt, а байты ({size}) освобождаются. Это docker image rm данной модели — не побочный эффект, а сама операция.',
    branchesTabHint: 'Наблюдаемые ветки этого репозитория: у каждой сегодняшние вершины — по одной на архитектуру — хронология обновлений и сколько названных ею образов лежит в кеше. Обновление — это «git fetch» репозитория: оно разрешает все его ветки разом.',
    noBranches: 'В этом репозитории не наблюдается ни одной ветки.',
    stopObserving: 'Прекратить наблюдение за веткой',
    pullBranch: 'Скачать в кэш голову branch (refresh разрешает, это скачивает)',
    pullDigest: 'Скачать в кэш этот digest',
    imageCount: 'Образы',
    deleteBranchPurgeTitle: 'Оставить образы {name} без имени?',
    deleteBranchPurgeBody: 'Ни одно приложение не называет эту ветку, но некоторые образы достижимы только через неё: при удалении они останутся в кеше без имени, перечисленные среди образов репозитория и удаляемые вручную.',
    deleteBranchPurgeConfirm: 'Удалить и оставить образы без имени',
    imagesTabHint: 'Образы этого репозитория — содержимое, то есть дайджесты — видны и без выбора ветки. Образ уникален для кластера: имён, которые до него доходят, может быть несколько.',
    noImages: 'Ни один образ этого репозитория не материализован в кеше.',
    deleteRepositoryTitle: 'Удалить {name}?',
    deleteRepositoryBody: 'Репозиторий и его ветки исчезают вместе с хронологией. Образы остаются в кеше: они теряют только это имя. Репозиторий, названный приложением, удалить нельзя.',
    provenanceCatalog: 'каталог',
    refreshedAt: 'Обновлено',
    neverRefreshed: 'Никогда не обновлялось',
    sectionBranches: 'Ветки',
    sectionImages: 'Образы',
    repositoriesGovernedElsewhere: 'Здесь репозитории только просматриваются: регистрация, обновление, наблюдение за ветками и удаление образов делаются в разделе Образы OCI.',
    gotoImages: 'Перейти к Образам OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Поды',
    containers: 'Контейнеры',
    instances: 'Экземпляры',
    instancesTooltip: '{running} работает, {error} с ошибкой',
    placement: 'Размещение',
    spread: 'распределение',
    ha: 'HA',
    templateRevision: 'ревизия',
    deleting: 'Удаляется',
    empty: 'Подов нет — создайте приложение (один контейнер) или под из CLI (create-pod).',
    openInstances: 'Открыть экземпляры',
    rollingRestart: 'Поочерёдный перезапуск',
    scale: 'Масштабировать',
    scaleTitle: 'Масштабировать {name}',
    scaleHint: 'Число экземпляров (0–64): вверх занимается наименьший свободный номер, вниз отзывается наибольший, его постоянные данные сохраняются.',
    scaleError: 'Масштабирование не удалось',
    replicas: 'Реплики',
    deleteRunningError: '{name} работает — сначала остановите его.',
    deleteInstancesIntro: 'Все {count} экземпляров будут удалены.',
    stateRunning: 'Работает',
    stateStopped: 'Остановлен',
    editor: {
      createTitle: 'Создать Pod',
      create: 'Создать Pod',
      editTitle: 'Изменить Pod',
      nameHint: 'DNS-1123, не более 58 символов — экземпляры называются <имя>-<индекс>; неизменяемо после создания.',
      restartPolicy: 'Политика перезапуска',
      restartPolicyHint_always: 'Узел перезапускает любой завершившийся контейнер с экспоненциальной задержкой (10 с → 5 мин).',
      restartPolicyHint_onFailure: 'Перезапускается только контейнер с ненулевым кодом выхода; выход 0 остаётся в покое.',
      restartPolicyHint_never: 'Завершившийся контейнер остаётся как есть — экземпляр завершается как succeeded или failed.',
      grace: 'Отсрочка (с)',
      graceHint: 'Граница SIGTERM → SIGKILL при остановке.',
      hostname: 'Имя хоста',
      hostnameHint: 'Пусто = имя экземпляра.',
      hostnameDefault: 'имя экземпляра',
      sharePid: 'Разделять пространство имён PID между контейнерами',
      containersIntro: 'Init-контейнеры выполняются до конца, по порядку, до запуска контейнеров; контейнеры делят сеть экземпляра (один IP, localhost между ними).',
      initContainers: 'Init-контейнеры',
      initAdd: 'Добавить init-контейнер',
      initHint: 'Каждый должен завершиться с 0; сбой переводит экземпляр в ошибку, и узел повторяет его с задержкой.',
      containerAdd: 'Добавить контейнер',
      atLeastOne: 'Pod нуждается как минимум в одном контейнере.',
      duplicateNames: 'Имена контейнеров должны быть уникальны в Pod (включая init-контейнеры).',
      containerName: 'Имя контейнера',
      containerInvalid: 'Этот контейнер неполон: имя (DNS-1123), образ, монтирования на объявленные тома, числовые лимиты и проба.',
      command: 'Команда',
      commandHint: 'Переопределяет entrypoint образа — один аргумент в строке, никогда не строка оболочки.',
      args: 'Аргументы',
      argsHint: 'По одному в строке (CMD образа, если пусто).',
      mounts: 'Монтирования',
      mountAdd: 'Добавить монтирование',
      mountNoVolumes: 'Сначала объявите том на вкладке Хранилище.',
      readOnly: 'только чтение',
      resources: 'Лимиты',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (напр. 1.5)',
      memory: 'Память (MiB)',
      memoryHint: 'podman --memory',
      health: 'Проба живости',
      healthCmd: 'Команда пробы',
      healthCmdHint: 'Выполняется узлом внутри контейнера на каждом такте надзора — один аргумент в строке; выход 0 = здоров.',
      healthTimeout: 'Тайм-аут (с)',
      healthRetries: 'Попытки',
      healthRetriesHint: 'Подряд идущие сбои, после которых узел перезапустит контейнер.',
      ips: 'Статические адреса',
      ipsHint: 'По одному на экземпляр, в порядке номеров — масштабирование за пределы списка отклоняется.',
      instance: 'экземпляр',
      volumesHint: 'Тома принадлежат Pod; путь монтирования — каждому контейнеру (вкладка Контейнеры).',
      spread: 'Распределение',
      spreadHint_preferred: 'Экземпляры на разных узлах, когда возможно.',
      spreadHint_required: 'Экземпляры на разных узлах, иначе масштабирование отклоняется.',
      spreadHint_none: 'Только планировщик.',
      ha: 'Высокая доступность (opt-in)',
      haHint: 'Каждая постоянная часть на общем storage; если узел умрёт, HA decider пересоздаст экземпляры на другом члене (автоматический failover, как у HA VM).',
      yes: 'да',
      no: 'нет'
    },
    detail: {
      container: 'Контейнер',
      actions: 'Действия',
      ready: 'Готов',
      notReady: 'Не готов',
      restarts: 'Перезапуски',
      lastRestartAt: 'Последний перезапуск:',
      backoffUntil: 'Повтор в',
      stateAbsent: 'отсутствует',
      stateRunning: 'работает',
      stateTerminated: 'завершён',
      stateWaiting: 'ожидает',
      init: 'init',
      noInstances: 'Нет экземпляров (реплик 0).',
      ha: 'HA',
      haHint: 'Автоматический failover: если узел умрёт, HA decider пересоздаст экземпляр на другом члене (каждая постоянная часть на общем storage).',
      authority: 'Authority (узел)',
      homeless: 'без authority',
      homelessHint: 'Восстановление из checkpoint не включает authority (#380): ни один узел не обслуживает его, пока вы не масштабируете Pod (хотя бы до того же числа реплик).',
      restartContainer: 'Перезапустить только этот контейнер (pod остаётся работать)',
      divergingHint: 'Желаемое состояние этого экземпляра отличается от значения по умолчанию Pod (PD-P19).',
      revisionLag: 'ревизия {applied} применена из {current}',
      updatedInstances: '{updated}/{desired} экземпляров на этой ревизии'
    }
  }
}
